import styles from './css/RecoveryEmailSent.css';

import React from 'react';
import propTypes from 'prop-types';
import { Button, Icon, Link } from '@tcc/crate';
import { getMessage } from '../../i18n/i18nWrapper';

import ContactSupportInfo from '../../components/passwordRecovery/ContactSupportInfo';

const RecoveryEmailSent = ({supportEmail, supportPhoneNumber, isCountryKnown}) => {

  return (
    <div className={styles.container}>
      <div className={styles.card}>

        <div className={styles.logoContainer} data-test-id="climate-fv-logo">
          <Icon className={styles.logo} glyph={Icon.set.CLIMATE_PORTAL_COLOR} />
        </div>

        <p className={styles.title} data-test-id="password-recovery-title">
          {getMessage('recoveryEmailSentSuccess.title')}
        </p>

        <p className={styles.message} data-test-id="recovery-email-sent-message">
          {getMessage('recoveryEmailSentSuccess.blurb')}
        </p>

        <Link data-test-id="back-to-login" href={`${window.location.pathname}#/`}>
          <Button className={styles.button} mode="primary">
            {getMessage('recoveryEmailSentSuccess.button')}
          </Button>
        </Link>
      </div>

      <div className={styles.divider} />

      <ContactSupportInfo
        isCountryKnown={isCountryKnown}
        supportEmail={supportEmail}
        supportPhoneNumber={supportPhoneNumber}
      />
    </div>
  );
};

RecoveryEmailSent.propTypes = {
  isCountryKnown: propTypes.bool.isRequired,
  supportEmail: propTypes.string.isRequired,
  supportPhoneNumber: propTypes.string.isRequired
};

export default RecoveryEmailSent;
